import { CapoPlugin } from "/home/manohar/dev/mall-nuxt/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];